import styled from 'styled-components';

/** Liste des sous-catégorie, sous forme d'une liste non ordonnée */
export const List = styled.ul`
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
`;

/** Sous-catégorie masqués par défaut. Affichage en flex via `CategoryGrid` */
export const Item = styled.li`
  display: flex;

  gap: 8px;
  align-items: center;

  a {
    flex: 0 1 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    font-size: 14px;
    line-height: 28px;
    color: ${({ theme }) => theme.palette.text};

    &:hover {
      color: ${({ theme }) => theme.palette.common.PRIMARY_HOVER};
    }
  }
`;
